// batch.js — how a workshop batch is named in the UI.
// Perpanjangan sertifikasi (re-certification) lives in a dummy batch numbered 99 with a far-future date. It is never
// shown as "Batch 99" and its dummy date/place/time are not shown either. The API only lists it on a program page
// for logged-in alumni of that program (backend app/Services/Recertification.php).

export const RECERT_BATCH = 99
export const RECERT_LABEL = 'Perpanjangan Sertifikasi'

export function isRecertBatch(batch) {
  return batch !== null && batch !== undefined && batch !== '' && Number(batch) === RECERT_BATCH
}

/** "Batch 7" (or "<prefix> 7"), and "Perpanjangan Sertifikasi" for the recert batch. */
export function batchLabel(batch, prefix = 'Batch') {
  return isRecertBatch(batch) ? RECERT_LABEL : `${prefix} ${batch}`
}

/** Index of the batch a program page opens on: the first one that has not ended yet, else the first. */
export function defaultBatchIndex(batches, today = new Date()) {
  if (!Array.isArray(batches) || !batches.length) return 0
  const day = new Date(today.getFullYear(), today.getMonth(), today.getDate())
  const open = batches.findIndex((b) => b && b.tanggal_selesai && new Date(b.tanggal_selesai + 'T00:00:00') >= day)
  return open >= 0 ? open : 0
}
